import React from 'react';

export const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <h3 className="text-lg font-medium text-gray-900 py-3 border-b border-gray-200 mb-4">
    {children}
  </h3>
);

export const Card = ({ children, className = "" }: { children: React.ReactNode, className?: string }) => (
  <div className={`bg-white rounded-lg shadow-sm border border-gray-100 p-5 ${className}`}>
    {children}
  </div>
);

// İleride başka paylaşılan bileşenler buraya eklenebilir
